module.exports = "<p>Это рынок бинарных прогнозов.</p>\n<p>Соотношение обеспечения для этого рынка составляет 1:1.</p>\n";